export default {
  state: {
    user: {
      id: null,
      email: null,
      pass: null,
      name: null,
      role: null,
      viewedVideos : [],
      payedFrom: null,
      payedTo: null,
    },
  },
  getters: {
    user(state) {
      return state.user
    }
  },
  mutations: {
    updateUser(state, user) {
      state.user.id = user.id,
      state.user.email = user.email,
      state.user.pass = user.pass,
      state.user.name = user.name,
      state.user.role = user.role,
      state.user.viewedVideos = user.viewedVideos,      
      state.user.payedFrom = user.payedFrom,
      state.user.payedTo = user.payedTo
    },
    clearUser(state) {
      state.user.id = null,
      state.user.email = null,
      state.user.pass = null,
      state.user.name = null,
      state.user.role = null,
      state.user.viewedVideos = [],
      state.user.payedFrom = null,
      state.user.payedTo = null
    },
    setViewedVideos(state, viewedVideos) {
      state.user.viewedVideos = viewedVideos      
    }
  },
  actions: {    
    async login({ dispatch, commit }, { email, islogin }) {      
      try {        
        const objectResponse = await dispatch("serverCall",{ 
          typeCall:"login", 
          pathVariable: null,
          data: { email, islogin }
        });
        if (objectResponse.bodyJson) {
          commit("updateUser", objectResponse.bodyJson.user)
        }        
      } catch (e) { }
    },

    async logout({ dispatch, commit }, { email, islogin }) {
      commit('clearUser');
      commit('clearCourseState');      
      commit("clearModeState");
      commit("clearRegimeState");
      try {        
        const objectResponse = await dispatch("serverCall",{ 
          typeCall:"logout", 
          pathVariable: null,
          data: { email, islogin }
        });                
      } catch (e) { }          
      commit('clearServerMsg');
    },

    async register({ dispatch, commit }, { email, pass, name }) {      
      try {        
        const objectResponse = await dispatch("serverCall",{ 
          typeCall:"register", 
          pathVariable: null,
          data: { email, pass, name }
        });
        if (objectResponse.bodyJson) {
          commit("updateUser", objectResponse.bodyJson.user)
        }        
      } catch (e) { }
    },    

    async changeUserData({ dispatch, commit }, { id, email, pass, name }) {      
      try {        
        const objectResponse = await dispatch("serverCall",{ 
          typeCall:"changeUserData", 
          pathVariable: null,
          data: { id, email, pass, name }
        });
        if (objectResponse.bodyJson) {
          commit("updateUser", objectResponse.bodyJson.user)
        }        
      } catch (e) { }
    },    

    async getCourseVideosSetViewed({ dispatch, commit }, { idUser, viewedVideos }) {      
      try {        
        const objectResponse = await dispatch("serverCall",{ 
          typeCall:"getCourseVideosSetViewed", 
          pathVariable: null,
          data: { idUser, viewedVideos }
        });
        if (objectResponse.bodyJson) {          
          commit("setViewedVideos",objectResponse.bodyJson.viewedVideos);
        }        
      } catch (e) { }
    }, 
    
  }
}
